import * as R from 'ramda'
import moment from 'moment'
import PouchDB from 'pouchdb-browser'
import React from 'react';
import ReactDOM from 'react-dom';
import { Router, browserHistory } from 'react-router'
import { applyMiddleware, compose, createStore } from 'redux'
import { Provider } from 'react-redux'
import { syncHistoryWithStore, routerMiddleware } from 'react-router-redux'
import MobileDetect from 'mobile-detect'
// import Perf from 'react-addons-perf'
import equals from 'shallow-equals'

import { saveState, restoreState } from 'utils/redux/localStorage'
import addLoggingToDispatch from 'utils/redux/addLoggingToDispatch'
import { storeEnhancer as search } from 'selectors/search'
import registerServiceWorker from 'utils/registerServiceWorker'

import 'app.css'

export default function app(config) {
	console.groupCollapsed('start')
	console.time('start')
	console.log('config', config)

	window.global = window

	// TODO: don't use mobile-detect, or at least don't make it global
	global.md = new MobileDetect(window.navigator.userAgent)

	let composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
	let enhancers = composeEnhancers(applyMiddleware(routerMiddleware(browserHistory)), search)
	let state = restoreState(config.appName)
	let store = createStore(config.reducers, state, enhancers)
	let history = syncHistoryWithStore(browserHistory, store)

	store.dispatch = addLoggingToDispatch(store)

	// Perf.start()
	let render = () => ReactDOM.render(
			<Provider store={store}>
		  		<Router history={history}>
					{config.routes(config)}
		  		</Router>
			</Provider>
	  , document.getElementById('root')
	)
	render()
	// Perf.stop()
	// let measurements = Perf.getLastMeasurements()
	// Perf.printExclusive(measurements)
	// Perf.printWasted(measurements)

	let resize = () => store.dispatch({ type: 'RESIZE', data: window.innerWidth })
	window.addEventListener('resize', resize)
	resize()

	let tick = () => store.dispatch({ type: 'CHANGE_TIME', data: new Date() })
	setInterval(tick, 60000)
	tick()

	store.subscribe(() => saveState(config.appName, store.getState()))

	registerServiceWorker()

	if (module.hot) {
		module.hot.accept(config.reducersPath, () => {
	  		const nextRootReducer = require(config.reducersPath).default
	  		store.replaceReducer(nextRootReducer)
		})
		module.hot.accept(config.routesPath, render)
	}

	console.timeEnd('start')
	console.groupEnd('start')

	// to hack in REPL
	global.store = store
}

// to hack in REPL
global.R = R
global.moment = moment
global.PouchDB = PouchDB
global.equals = equals
// global.Perf = Perf



// WEBPACK FOOTER //
// ./src/app.js